// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__170-e","footer":"ModalUpdate_footer__1Hj5x"};